<section class="table-content" *ngIf="dataSource">
    <!-- TODO handler when dada is empty in coherent way with matTableDataSource -->
    <div class="table-content__table-container ">
        <table mat-table matSort class=" mat-elevation-z8 " [dataSource]="dataSource ">
            <ng-container *ngFor="let column of tableColumns " [matColumnDef]="column.columnDef ">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                    {{ column.header }}
                </th>
                <td mat-cell *matCellDef="let element ">
                    <ng-container *ngIf="(column.columnDef| tableColumn:OverrideTableColumnsDirs) else defaultColumn; let overrideTableColumn " [ngTemplateOutlet]="overrideTableColumn.templateRef " [ngTemplateOutletContext]="{ $implicit: element, columnDef:column.columnDef
        } ">
                    </ng-container>
                    <ng-template #defaultColumn>
                        {{ element[column.columnDef] }}
                    </ng-template>
                </td>
            </ng-container>
            <ng-container *ngFor="let tableColumnDir of additionalTableColumnDirs" [matColumnDef]="tableColumnDir.tableColumn">
                <th mat-header-cell *matHeaderCellDef></th>
                <td mat-cell *matCellDef="let element " class="actions-button-cell ">
                    <ng-container [ngTemplateOutlet]="tableColumnDir.templateRef" [ngTemplateOutletContext]="{ $implicit: element } ">
                    </ng-container>
                </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="columns "></tr>
            <tr mat-row *matRowDef="let row; columns: columns " [ngClass]="{disabled: row.disabled}"></tr>
        </table>
        <mat-paginator class="mat-elevation-z8 " [pageSizeOptions]="[10, 20, 50] " [hidePageSize]="true " showFirstLastButtons aria-label="Select page of periodic dataSource ">
        </mat-paginator>
    </div>
</section>